import {Modal} from "../../../../../components/modal/modal.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import Button from "../../../../../components/button/button.jsx";
import {useMutation, useQuery} from "@tanstack/react-query";
import BosService from "../../../../../services/web/bos-service.js";
import {useContext, useEffect, useState} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import ProjectUtils from "../../../../../utils/project-utils.js";
import {toast} from "react-toastify";

export default function BoShowTagsModal({ open, setOpen }) {
    const { id, tagsId = [], refetch } = useContext(BoShowContext);

    const [selectedTags, setSelectedTags] = useState([]);

    const { data: options = [] } = useQuery({
        queryKey: ['tags-options'],
        queryFn: () => BosService.getTagOptions(),
    });

    useEffect(() => {
        setSelectedTags(Array.isArray(tagsId) ? tagsId : []);
    }, [tagsId]);

    const updateTagsMutation = useMutation({
        mutationFn: BosService.updateTags,
        onSuccess: async () => {
            await refetch();
            setSelectedTags([]);
            setOpen(false);

            toast.success("Salvo com sucesso");
        },
        onError: (error) => {
            console.error("Erro ao salvar marcadores: ", error?.response?.data ?? error);

            const message = error?.response?.data?.message ?? "Não foi possível salvar.";
            ProjectUtils.swalErrorMessage("", message, "Ok");
        }
    });

    const addTag = () => {
        const fd = new FormData();

        fd.append("id", id);
        fd.append("tagsIds", JSON.stringify(selectedTags.map(tag => tag.value)));

        updateTagsMutation.mutate(fd);
    }

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title={`Selecione um marcador`}
            className="w-4/12"
            isCloseClick={false}
        >
            <Modal.Body className="space-y-2">
                <SelectComponent
                    id="tag_name"
                    label="Marcador"
                    classNameWrapper="flex-1"
                    isMulti
                    options={options}
                    value={selectedTags}
                    onChange={(option) => setSelectedTags(option ?? [])}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={addTag} actionFeedbackType='save'>

                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}